import { Meteor } from 'meteor/meteor'

import history from './history'
import { getProfileRegistar } from './fonction'
import { getStepsRegistar } from './lib/routes'

const routeDefine = [
  {
    path: ['/login', '/'],
    nextRoutes: [
      {
        path: '/home-lawyer',
        condition: ({ profile }) => profile.type === 'lawyer',
      },
      {
        path: '/note',
        condition: ({ callId }) => !!callId && callId !== '',
      },
      {
        path: '/result-lawyer',
        condition: ({ valueAutocomplete }) =>
          !!valueAutocomplete && Object.keys(valueAutocomplete).length > 0,
      },
    ],
  },
  {
    path: '/profile',
    nextRoutes: [
      {
        path: '/my-sub-account',
        condition: ({ newUserChildrenPro, userId }) =>
          !!newUserChildrenPro || (!!userId && userId !== ''),
      },
    ],
  },
  {
    path: '/payment',
    nextRoutes: [
      {
        path: '/iban',
        condition: ({ type }) => type === 'iban',
      },
      {
        path: '/cheque',
        condition: ({ type }) => type === 'cheque',
      },
      {
        path: '/paymentedit',
        condition: ({ editCb }) => !!editCb,
      },
      {
        path: '/callQuestions',
        condition: ({ lawyerId }) => !!lawyerId && lawyerId !== '',
      },
      {
        path: '/',
        condition: ({ preAuthorizationId }) => !!preAuthorizationId && preAuthorizationId !== '',
      },
    ],
  },
  {
    path: '/paymentCall',
    nextRoutes: [
      {
        path: '/callQuestions',
        condition: ({ lawyerId }) => !!lawyerId && lawyerId !== '',
      },
    ],
  },
  {
    path: '/home-lawyer',
    nextRoutes: [
      {
        path: '/availability-lawyer',
        condition: ({ updateDispo }) => !!updateDispo && updateDispo === true,
      },
      {
        path: '/note-lawyer',
        condition: ({ profile, callId }) => profile.type === 'lawyer' && !!callId && callId !== '',
      },
      {
        path: '/result-lawyer-select',
        condition: ({ goToViewCustomer, lawyerId }) =>
          !!goToViewCustomer && goToViewCustomer === true && !!lawyerId && lawyerId !== '',
      },
      {
        path: '/profile-lawyer',
        condition: ({ profile }) => profile.type === 'lawyer',
      },
    ],
  },
  {
    path: '/result-lawyer',
    nextRoutes: [
      {
        path: '/result-lawyer-select',
        condition: ({ lawyerId }) => !!lawyerId && lawyerId !== '',
      },
      {
        path: '/result-lawyer',
        condition: ({ subCategoriesSelected, valueAutocomplete }) =>
          (!!subCategoriesSelected && Object.keys(subCategoriesSelected).length > 0) ||
          (!!valueAutocomplete && Object.keys(valueAutocomplete).length > 0),
      },
    ],
  },

  //@FIXME: Creer une nouvelle route pour le choix des offres coté appels (?)
  {
    path: '/choose-offers',
    nextRoutes: [
      {
        path: '/paymentCall',
        condition: ({ routeName }) => !!routeName && routeName === 'PaymentVerification',
      },
      {
        path: '/profile',
        condition: ({ lawyerId }) => lawyerId === undefined,
      },
    ],
  },

  {
    path: ['/result-lawyer-select'],
    nextRoutes: [
      {
        path: '/result-lawyer',
        condition: ({ backResult }) => !!backResult && backResult === true,
      },
      {
        path: '/callQuestions',
        condition: ({ routeName }) => !!routeName && routeName === 'CallQuestions',
      },
      {
        path: '/choose-offers',
        condition: ({ routeName }) => !!routeName && routeName === 'ChooseOffers',
      },
      {
        path: '/paymentCall',
        condition: ({ routeName }) => !!routeName && routeName === 'PaymentVerification',
      },
    ],
  },
  {
    path: ['/paymentedit', '/iban', '/cheque'],
    nextRoutes: [
      {
        path: '/paymentCall',
        condition: ({ lawyerId }) => !!lawyerId && lawyerId !== '',
      },
    ],
  },
  {
    path: '/callQuestions',
    nextRoutes: [
      {
        path: '/callStatus',
        condition: ({ callId, lawyerId }) =>
          !!callId && !!lawyerId && callId !== '' && lawyerId !== '',
      },
      {
        path: '/result-lawyer-select',
        condition: ({ cancelCall }) => !!cancelCall && cancelCall === true,
      },
    ],
  },
  {
    path: '/callStatus',
    nextRoutes: [
      {
        path: '/note',
        condition: ({ goToNotation }) => !!goToNotation && goToNotation === true,
      },
      {
        path: '/result-lawyer-select',
        condition: ({ lawyerId, viewProfilOnly }) =>
          !!lawyerId && lawyerId !== '' && !!viewProfilOnly,
      },
      {
        path: '/callStatus',
        condition: ({ callId, lawyerId }) => {
          return !!callId && !!lawyerId && callId !== '' && lawyerId !== ''
        },
      },
      {
        path: '/result-lawyer',
        condition: ({ callOtherLawyer }) => !!callOtherLawyer && callOtherLawyer === true,
      },
      {
        path: '/',
        condition: ({ abortCall }) => !!abortCall && abortCall === true,
      },
    ],
  },
]

export const getNextPage = (args) => {
  const profileRegistar = getProfileRegistar()

  if (!!profileRegistar) {
    // Si on est en cours d'inscription ou que l'inscription a été abandonné on redirige vers le formulaire.
    // Cela s'active sur n'importe quelle route actuelle
    const stepsRegistar = getStepsRegistar()

    const actualPageIndex = stepsRegistar.findIndex((r) => r.path === history.location.pathname)
    const nextPage = stepsRegistar[actualPageIndex ? actualPageIndex + 1 : 0]

    if (!!nextPage) {
      history.push(nextPage.path, { ...nextPage.moreProps })
    } else {
      history.push('/')
    }
  } else {
    const routeActuelle = routeDefine.find((i) => {
      if (typeof i.path === 'object') {
        return !!i.path.find((iPath) => iPath === history.location.pathname)
      } else return i.path === history.location.pathname
    })
    const { profile = null } = Meteor.user() || {}

    const routeDefault = {
      path: profile?.type === 'lawyer' ? '/home-lawyer' : '/',
      moreProps: args,
    }
    const newRoute = { path: '', moreProps: {} }
    !!routeActuelle &&
      routeActuelle.nextRoutes.forEach((uneRoute) => {
        const condition =
          (uneRoute.condition && uneRoute.condition({ profile, profileRegistar, ...args })) ||
          uneRoute.condition === undefined

        if (newRoute.path === '' && condition) {
          newRoute.path = uneRoute.path
          newRoute.moreProps = { ...uneRoute.moreProps, ...args }
        }
      })

    const routeSelect = newRoute.path !== '' ? newRoute : routeDefault

    history.push(routeSelect.path, { ...routeSelect.moreProps })
  }
}
